import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskLine, Eyebrow } from "./motion";
import { waLink, IMG } from "./data";

const CATS = [
    {
        id: "men",
        name: "Men’s Wear",
        desc: "Shirts, trousers, ethnic & everyday essentials in deep sizes.",
        img: IMG.men,
        span: "md:col-span-7",
    },
    {
        id: "women",
        name: "Women’s Wear",
        desc: "Ethnic, festive & daily fashion for every age group.",
        img: IMG.women,
        span: "md:col-span-5",
    },
    {
        id: "kids",
        name: "Kids Collection",
        desc: "Comfort-first festive & daily wear for little ones.",
        img: IMG.kids,
        span: "md:col-span-5",
    },
    {
        id: "fabrics",
        name: "Fabric Rolls & Dress Material",
        desc: "Unstitched fabric by the roll — suitings, dress material & more.",
        img: IMG.fabric,
        span: "md:col-span-7",
    },
];

export default function Categories() {
    return (
        <section id="collections" data-testid="collections-section" className="bg-cream py-24 text-ink lg:py-32">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
                    <div className="max-w-2xl">
                        <Reveal>
                            <Eyebrow className="!text-[#A97F1C]">What We Stock</Eyebrow>
                        </Reveal>
                        <h2 className="mt-4 font-display text-4xl font-bold leading-[1.02] tracking-tight text-maroon-900 sm:text-5xl lg:text-6xl">
                            <MaskLine>One Store,</MaskLine>
                            <MaskLine delay={0.1} className="italic font-light text-[#A97F1C]">
                                The Whole Family.
                            </MaskLine>
                        </h2>
                        <Reveal delay={0.2}>
                            <p className="mt-5 max-w-xl text-base leading-relaxed text-ink/65 sm:text-lg">
                                From daily wear to festive collections — everything a family needs,
                                stocked deep for shop owners. Rates &amp; catalogue on WhatsApp, never on a tag.
                            </p>
                        </Reveal>
                    </div>
                    <Reveal delay={0.25}>
                        <span
                            data-testid="collections-wholesale-chip"
                            className="inline-flex items-center rounded-full border border-maroon-900/25 bg-maroon-900 px-5 py-2.5 text-[11px] font-bold uppercase tracking-[0.22em] text-gold"
                        >
                            Strictly Wholesale • No Retail Prices
                        </span>
                    </Reveal>
                </div>

                <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-12 md:gap-6">
                    {CATS.map((c, i) => (
                        <Reveal key={c.id} delay={i * 0.08} className={`${c.span} h-full`}>
                            <article
                                data-testid={`category-card-${c.id}`}
                                className="group relative h-[320px] overflow-hidden rounded-[1.75rem] border border-maroon-900/10 md:h-[430px]"
                            >
                                <img
                                    src={c.img}
                                    alt={c.name}
                                    loading="lazy"
                                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
                                />
                                <div
                                    className="pointer-events-none absolute inset-0"
                                    style={{
                                        background:
                                            "linear-gradient(180deg, rgba(38,6,11,0.05) 30%, rgba(38,6,11,0.55) 62%, rgba(38,6,11,0.94) 100%)",
                                    }}
                                    aria-hidden="true"
                                />
                                <span className="absolute left-5 top-5 rounded-full bg-gold px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-[0.22em] text-maroon-950">
                                    Wholesale
                                </span>
                                <div className="absolute inset-x-0 bottom-0 p-6 sm:p-8">
                                    <h3 className="font-display text-2xl font-bold text-cream sm:text-3xl">
                                        {c.name}
                                    </h3>
                                    <p className="mt-2 max-w-sm text-sm leading-relaxed text-cream/75">
                                        {c.desc}
                                    </p>
                                    <a
                                        href={waLink(`Namaste! Please share wholesale rates for ${c.name} at Baba Garments.`)}
                                        target="_blank"
                                        rel="noreferrer"
                                        data-testid={`category-wa-link-${c.id}`}
                                        className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-gold transition-colors duration-300 hover:text-gold-pale"
                                    >
                                        Ask rates on WhatsApp
                                        <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                                    </a>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}